import { useTranslation } from 'react-i18next'

import { ErrorPage } from '../../../components/guest/errorPage/ErrorPage'

export const NotFound = () => {
  const { t } = useTranslation('common')

  return (
    <ErrorPage
      code={404}
      message={t('not-found.status')}
      title={t('not-found.title.before')}
      highlightedTitle={t('not-found.title.highlight')}
      description={t('not-found.label')}
      actionLabel={t('not-found.back-btn')}
    />
  )
}
